exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".with-select-all-tree .custom-tree-node {\n  display: inline-block;\n  width: 100%;\n  padding-right: 0.052083rem;\n}\n.with-select-all-tree .custom-tree-node .add-icon {\n  float: right;\n  color: #409eff;\n}\n.with-select-all-tree .custom-tree-node .add-icon:hover {\n  color: #66b1ff;\n}\n.with-select-all-tree .el-tree {\n  width: 2.604167rem;\n}", ""]);

// exports
